import { START_LOADING, END_LOADING, UPDATE_LOADING_MESSAGE } from '@app/actions/_types';

const initialSpinnerState = {
  show: false,
  message: null,
};

export default (state = initialSpinnerState, { type, payload = 'qau-status-loading' } = {}) => {
  switch (type) {
    case START_LOADING:
      return { show: true, message: payload };
    case UPDATE_LOADING_MESSAGE:
      return { ...state, message: payload };
    case END_LOADING:
      return { show: false, message: null };
    default:
      return state;
  }
};
